/**
 * CCC Custom Collection Sort
 *
 * Re-sorts the product grid by coffee.price_per_kg when a price sort is active.
 * Products with the metafield sort by /kg price; products without it sort by
 * their variant price. Non-coffee products always sort below/above coffee
 * products depending on direction.
 *
 * Hooks into the existing facets system via MutationObserver on the grid,
 * which fires after the section-renderer morphs new HTML into the DOM.
 */
(function () {
  'use strict';

  /**
   * Gets the active sort_by value from the URL
   * @returns {string|null}
   */
  function getActiveSortBy() {
    return new URL(window.location.href).searchParams.get('sort_by');
  }

  /**
   * Returns the sort price for a grid item.
   * Uses price_per_kg if available (coffee), otherwise variant price converted from cents to dollars.
   * @param {HTMLElement} item
   * @returns {number}
   */
  function getSortPrice(item) {
    const kgPrice = item.dataset.pricePerKg;
    if (kgPrice != null && kgPrice !== '') {
      return parseFloat(kgPrice);
    }
    // variant price is in cents
    const variantPrice = item.dataset.variantPrice;
    if (variantPrice != null && variantPrice !== '') {
      return parseFloat(variantPrice) / 100;
    }
    return 0;
  }

  /**
   * Re-sorts the product grid based on price_per_kg when price sort is active.
   */
  function resortGrid() {
    const sortBy = getActiveSortBy();
    if (sortBy !== 'price-ascending' && sortBy !== 'price-descending') return;

    const grid = document.querySelector('.product-grid[ref="grid"]');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('.product-grid__item'));
    if (items.length === 0) return;

    // Check if any items have price-per-kg data — if none do, skip (not a coffee collection)
    const hasCoffeeProducts = items.some(function (item) {
      return item.dataset.pricePerKg != null && item.dataset.pricePerKg !== '';
    });
    if (!hasCoffeeProducts) return;

    const ascending = sortBy === 'price-ascending';

    items.sort(function (a, b) {
      var priceA = getSortPrice(a);
      var priceB = getSortPrice(b);
      return ascending ? priceA - priceB : priceB - priceA;
    });

    // Pause observer while we reorder to avoid infinite loop
    if (observer) observer.disconnect();

    items.forEach(function (item) {
      grid.appendChild(item);
    });

    if (observer) observeGrid();
  }

  var observer = null;

  function observeGrid() {
    var grid = document.querySelector('.product-grid[ref="grid"]');
    if (!grid) return;

    observer = new MutationObserver(function () {
      // Debounce — morph may fire multiple mutations
      clearTimeout(observer._timeout);
      observer._timeout = setTimeout(resortGrid, 50);
    });

    observer.observe(grid, { childList: true });
  }

  // Also listen for popstate (browser back/forward with sort params)
  window.addEventListener('popstate', function () {
    setTimeout(resortGrid, 100);
  });

  // Initial sort on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      resortGrid();
      observeGrid();
    });
  } else {
    resortGrid();
    observeGrid();
  }
})();
